//Action Types
export const SET_PREFERRED_THEME = "SET_PREFERRED_THEME";

//Action Creators
export const setPreferredTheme = value => ({
  type: SET_PREFERRED_THEME,
  value
});
